import UrlUtils from '@spothero/utils/url';
import SearchUtils from 'utils/search-utils';
export const isInitialDataRedirect = (data) => Boolean(data) && typeof data.redirect === 'string';
export const isInitialDataNotFound = (data) => Boolean(data) && data.notFound === true;
export const toSearchString = (query) => UrlUtils.createQueryString(query);
export const buildSearchInitialData = ({ city, destination, searchType, freshSearchRequest, }) => ({
    city,
    destination,
    search: {
        data: {
            ...SearchUtils.defaultSearchSettings,
            searchType,
            breadcrumbs: SearchUtils.prepareBreadcrumbs({ city, destination, searchRequest: freshSearchRequest }, searchType),
        },
    },
    searchRequest: freshSearchRequest,
});
